export default __webpack_public_path__ + "static/media/grid-hc.978c88c2.svg";